import React from "react";
import AboutBgLanding from "./AboutBgLanding";
import OurStory from "./OurStory";
import OurStoryTwo from "./OurStoryTwo";
import { Box } from "@mui/material";
import OurValues from "./OurValues";
import AboutUsOurDifferentiation from "./AboutUsOurDifferentiation";
import TeamSlider from "../../components/slider/TeamSlider";
import OurPartners from "./OurPartners";
import PartnerSlider from "../../components/slider/PartnerSlider";
import DualMarqueeSlider from "../../components/GallerySlider";
import { Helmet } from "react-helmet";

const Aboutus = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | About Us</title>
        <meta
          name="description"
          content="We Provide Tailor-made Solutions for Your Business Questions Empowering Decisions with Data-Driven Intelligence for Smarter Strategies & Growth "
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <AboutBgLanding />
        <OurStory />
        <OurStoryTwo />
        <OurValues />
        <AboutUsOurDifferentiation />
        <OurPartners />
        <PartnerSlider />
        <DualMarqueeSlider />
      </Box>
    </>
  );
};

export default Aboutus;
